export default "__VITE_ASSET__CUPPn9W8__"